module.exports = __webpack_public_path__ + "img/mysair-logo.09dd3c0c.svg";